import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import tippy from 'tippy.js'; //require('$-qrcode')

/**
 * Marker is class for managing the marker of one user,it includes the caret, avatar, and pseudo Names.
 */

import neighborhoodJs from '../../docs/ast/source/crate-core/lib/spray-wrtc/lib/n2n-overlay-wrtc/lib/neighborhood-wrtc/lib/neighborhood.js.json';
export var StatesHeader =
/*#__PURE__*/
function () {
  /**
   * StatesHeader is class that is for showing the state of the network, share option of the document.
   * @param  {[type]} model     [description]
   * @param  {[type]} linkView  [description]
   * @param  {[type]} shareView [description]
   * @return {[type]}           [description]
   */
  function StatesHeader(model, linkView, shareView, editorContainerID) {
    var _this = this;

    _classCallCheck(this, StatesHeader);

    this.document = model;
    this.startSharingText = '<i class="fa fa-link fa-2x ficon2"></i>';
    this.startSharingTooltip = 'start sharing';
    this.stopSharingText = '<i class="fa fa-unlink fa-2x ficon2"></i>';
    this.stopSharingTooltip = 'stop sharing';
    this.red = '#cd2626';
    this.yellow = '#eead0e';
    this.green = '#228b22';
    this.blue = '#00BFFF';
    this._editorContainerID = editorContainerID;
    this.networkState = $("#".concat(this._editorContainerID, " #state"));
    tippy("#".concat(this._editorContainerID, " #state"), {
      content: 'Network state',
      theme: 'light rounded',
      delay: 100,
      arrow: true
    });
    tippy("#".concat(this._editorContainerID, " #saveicon"), {
      content: 'Save document',
      theme: 'light rounded',
      delay: 100,
      arrow: true
    });
    tippy("#".concat(this._editorContainerID, " #remotesave"), {
      content: 'Remote save',
      theme: 'light rounded',
      delay: 100,
      arrow: true
    });
    var sharingContainer = $("#".concat(this._editorContainerID, " #sharingContainer"));
    var shareIcon = $("#".concat(this._editorContainerID, " #shareicon"));
    var link = window.location.href.split('/');
    link.splice(-1, 1);
    link = link.join('/') + '/' + this.document.documentId;

    var getTitle = function getTitle() {
      var title = $("#".concat(_this._editorContainerID, " #title")).text().replace(/(\r\n\t|\n|\r\t)/gm, '');
      return title;
    };

    sharingContainer.jsSocials({
      url: link,
      text: getTitle(),
      showLabel: false,
      showCount: false,
      shares: ['twitter', 'facebook', 'linkedin', 'whatsapp']
    });
    sharingContainer.append("<div id=\"link\" style=\"display: none;\">".concat(link, "</i>"));
    sharingContainer.prepend("<h5>Share!</h5>");
    $("#".concat(this._editorContainerID, " #sharingContainer .jssocials-shares")).append("<div class=\"jssocials-share\"><i id=\"copy\" class=\"fa fa-copy jssocials-share-logo\"></i></div>");
    $("#".concat(this._editorContainerID, " #sharingContainer #copy")).click(function () {
      _this.copyToClipboard(link);
    });
    tippy("#".concat(this._editorContainerID, " #shareicon"), {
      theme: 'light rounded',
      arrow: true,
      interactive: true,
      content: document.querySelector('#sharingContainer')
    });
    this.setNetworkState('partiallyConnected');
    this.document.on('connected', function () {
      _this.checkNetworkState();
    });
    this.document.rps.on('connect', function () {
      _this.checkNetworkState();
    });
    this.document.rps.on('data', function () {
      _this.checkNetworkState();
    });
    this.document.rps.on('stream', function () {
      _this.checkNetworkState();
    });
    this.document.rps.on('receive', function () {
      _this.checkNetworkState();
    });
    this.document.rps.on('open', function () {
      _this.checkNetworkState();
    });
    this.document.rps.on('close', function (id) {
      setTimeout(function () {
        _this.checkNetworkState();
      }, 0);
    });
  }

  _createClass(StatesHeader, [{
    key: "checkNetworkState",
    value: function checkNetworkState() {
      var neighborhoodSize = this.document._foglet.getNeighbours(Infinity).length;

      if (neighborhoodSize > 0) {
        this.setNetworkState('connected');
      } else if (neighborhoodSize === 0) {
        this.setNetworkState('partiallyConnected');
      }
    }
    /**
     * copyLink copy the link of the document
     * @return {[type]} [description]
     */

  }, {
    key: "copyToClipboard",
    value: function copyToClipboard(text) {
      var dummy = document.createElement('input');
      document.body.appendChild(dummy);
      dummy.setAttribute('value', text);
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    }
    /**
     * Set the state of the network on the browser
     * @param {[type]} state set three different states according Spray protocol states:'connected', 'partiallyconnected', and 'disconnected'
     */

  }, {
    key: "setNetworkState",
    value: function setNetworkState(state) {
      switch (state) {
        case 'connected':
          var connectedString = "<span class='alert-success'>Congratulations!</span>\n                     You are connected to people, and people are \n                     connected to you. <span class='alert-info'>You can start editing \" \n                     together</span>.";
          this.networkState.css('color', this.green);
          this.networkState.attr('data-content', connectedString);
          break;

        case 'partiallyConnected':
          var partiallyConnectedString = "<span class='alert-warning'>Partially connected</span>: \n                     either you are connected to people, or people are connected to you. \n                     This is not great, but you <span class='alert-info'> still can edit.</span>";
          this.networkState.css('color', this.yellow);
          this.networkState.attr('data-content', partiallyConnectedString);
          break;

        case 'disconnected':
          var disconnectedString = "<span class='alert-danger'>Disconnected</span>:\n                     you are currently editing <span class='alert-info'>on\n                    your own</span>.";
          this.networkState.css('color', this.red);
          this.networkState.attr('data-content', disconnectedString);
          break;
      }
    }
  }]);

  return StatesHeader;
}();